import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Hero = () => (
  <section className="relative min-h-screen flex items-end pb-24 lg:pb-32" data-testid="hero-section">
    <div className="absolute inset-0 z-0">
      <img src="https://customer-assets-agu9un31.emergentagent.net/job_squash-nexus/artifacts/lv620un0_a95dc438-10f2-4e5e-8c62-e869c2453074.jpeg" alt=""
        className="w-full h-full object-cover" />
      <div className="hero-gradient absolute inset-0"></div>
    </div>

    <div className="container-custom relative z-10 w-full">
      <div className="max-w-xl">
        <p className="overline mb-8 animate-fade-in">LRG Squash</p>

        <h1 className="font-editorial text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.05] text-[#F2EDE4] mb-8 animate-fade-in animate-delay-100">
          The next level<br />starts here.
        </h1>

        <p className="text-sm text-[#6B6E71] mb-14 max-w-sm leading-[1.8] animate-fade-in animate-delay-200">
          Elite training and a competitive home for every squash player.
        </p>

        <div className="flex flex-wrap gap-4 animate-fade-in animate-delay-300">
          <Link to="/contact" className="btn-primary" data-testid="hero-cta-start">
            Start Your Journey <ArrowRight className="w-3.5 h-3.5" />
          </Link>
          <Link to="/baltimore" className="btn-secondary" data-testid="hero-cta-baltimore">Baltimore</Link>
          <Link to="/princeton" className="btn-secondary" data-testid="hero-cta-princeton">Princeton</Link>
        </div>
      </div>
    </div>

    <div className="absolute bottom-8 right-8 z-10 hidden lg:block">
      <p className="text-[9px] tracking-[0.4em] uppercase text-[#3A3D40] writing-mode-vertical" style={{ writingMode: 'vertical-rl' }}>
        High Performance Development
      </p>
    </div>
  </section>
);

export default Hero;
